import styled from 'styled-components';
import { asRem } from 'utils/asRem';
import { mediaQueries } from 'utils/Constants/Breakpoints';
import bgImageMobile from 'img/bgr_waves_mobile.svg';
import bgImage from 'img/bgr_waves.svg';
import { breakpoints, colors } from 'View/Theme';

export default styled.main.attrs({ className: 'landingpage' })`
  padding-left: 0;
  padding-right: 0;
  position: relative;
  z-index: 1;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: center;
  background-image: url(${bgImageMobile});
  background-repeat: no-repeat;
  background-size: cover;
  min-height: 100vh;
  overflow: hidden;
  color: ${colors.sleep.beige.c100};

  ${mediaQueries.md} {
    background-image: url(${bgImage});
  }

  h2 {
    color: ${colors.sleep.beige.c100};
  }

  .break-md {
    display: none;
  }
  @media (min-width: 768px) {
    .break-md {
      display: inline;
    }
  }

  .mime-elements-section {
    .container {
      max-width: ${asRem(944)};
    }

    &[type='full-width'] .container {
      max-width: 100%;
    }
  }

  .navbar-down {
    background-color: var(--sleep-blue-c700) !important;
    box-shadow: none !important;
  }

  .paragraph-section {
    .mime-elements-paragraph {
      padding: ${asRem(24)};
    }
  }

  .intro-form-paragraph > a {
    font-weight: 600;
  }

  .go-app-button {
    width: ${asRem(213)};
    margin-right: auto;
    margin-left: auto;
    margin-bottom: var(--sleep-gutter-s) !important;
  }

  .mime-elements-toggle p {
    margin-left: ${asRem(4)};
    margin-top: ${asRem(8)};
    margin-bottom: ${asRem(4)};
    font-size: 14px;
    font-weight: 400;
  }

  .form-insurance-number-subtext {
    margin-top: ${asRem(-10)};
    padding-top: ${asRem(2)};
    font-size: ${asRem(14)};
  }

  .form-opt-out-notice {
    border-top: ${asRem(2)} solid var(--sleep-blue-c200);
    margin-top: ${asRem(20)};
    padding-top: ${asRem(20)};
    font-size: ${asRem(14)};
  }

  .legal-newsletter-info {
    border-top: ${asRem(1)} solid var(--sleep-blue-c200);
    padding: ${asRem(24)} ${asRem(4)} 0 ${asRem(4)};
    margin-top: ${asRem(32)};
  }

  .paragraph-section {
    .text-block-img {
      margin-bottom: 0;
    }

    .mime-elements-paragraph {
      padding: 0 ${asRem(24)};
      margin: 0;

      @media (min-width: ${breakpoints.md}) {
        padding: ${asRem(24)};
      }
    }
  }

  .form-view {
    margin: 0 auto;
    max-width: ${asRem(640)};
    display: block;
  }

  .form-section {
    padding: 0;
    background-color: var(--sleep-blue-c770);

    ${mediaQueries.md} {
      background-color: transparent;
    }

    p a.mail-link,
    .Paragraph a.mail-link {
      font-family: var(--sleep-fontfamily2) !important;
      text-decoration: underline;
    }

    button.form-regulatory-link {
      font-family: var(--sleep-fontfamily2) !important;
      font-size: ${asRem(14)};
    }
  }

  footer {
    width: 100%;
  }

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    -webkit-background-clip: text;
    -webkit-text-fill-color: #ffffff;
    transition: background-color 5000s ease-in-out 0s;
    box-shadow: inset 0 0 20px 20px #23232329;
  }
`;
